import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type UseViewModelProps = {
  onCancel?: () => void;
  onSubmit: (reasonType: string, reason: string) => void;
};

type UseViewModelReturn = {
  reasonType: string;
  reason: string;
  reasonLength: number;
  handleReasonTypeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleReasonChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit: () => void;
  clearFields: () => void;
};

const useViewModel = ({
  onCancel,
  onSubmit,
}: UseViewModelProps): UseViewModelReturn => {
  const { t } = useTranslation();
  const [reasonType, setReasonType] = useState<string>(undefined);
  const [reason, setReason] = useState<string>(undefined);
  const reasonLength = useMemo(() => reason?.length || 0, [reason]);

  const handleReasonTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    setReasonType(event.target.value);
  };

  const handleReasonChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setReason(event.target.value);
  };

  const clearFields = (): void => {
    setReasonType(undefined);
    setReason(undefined);
    onCancel();
  };

  const handleSubmit = (): void => {
    // eslint-disable-next-line no-alert
    const isOk = window.confirm(
      t('request_refund.request_refund_dialog_message')
    );
    if (isOk) {
      onSubmit(reasonType, reason);
    }
    clearFields();
  };

  return {
    reasonType,
    reasonLength,
    reason,
    handleReasonTypeChange,
    handleReasonChange,
    handleSubmit,
    clearFields,
  };
};

export default useViewModel;
